import _ from 'lodash';

import client from '../client';

export async function count(searchParams) {
  return client.get(`/maestro/api/v1/stacks/_count?${searchParams}`);
}

export async function getById(stackId) {
  return client.get(`/maestro/api/v1/stacks/${stackId}`);
}

export async function list({length = 20, from, orderBy, searchQuery = ''}) {
  const searchParams = new URLSearchParams(searchQuery);
  searchParams.set('length', _.toString(length));
  if (from) {
    searchParams.set('from', from);
  }
  if (orderBy) {
    searchParams.set('orderBy', orderBy);
  }
  return client.get(`/maestro/api/v1/stacks?${searchParams}`);
}

export async function createStack(name) {
  return client.post(`/maestro/api/v1/stacks`, {name});
}

export async function updateStack(id, stackServices) {
  return client.patch(`/maestro/api/v1/stacks/${id}`, {stackServices});
}
